import { Action } from '@ngrx/store';
import { type } from 'services/actions-cache/actions-cache.service';
import { Certification } from '../../../objects/certification.object';
import { EntityImageConfig } from 'components/upload-image-modal';
import { DefaultActivityType } from 'components/organization-certification/step/education/general-ce-type/activity-type-control';
import { PublishCertificationData } from 'services/certs/certification.interface';
import { BriefNotificationsSettings } from 'features/organization-settings/notifications/organization-notifications.constants';

export namespace ActionCreators {
  export class GetCertificate implements Action {
    static readonly type = type<'[CERTIFICATE] GET_CERTIFICATE'>('[CERTIFICATE] GET_CERTIFICATE');
    readonly type = GetCertificate.type;

    constructor(public payload: number) {}
  }

  export class GetCertificateSuccess implements Action {
    static readonly type = type<'[CERTIFICATE] GET_CERTIFICATE_SUCCESS'>('[CERTIFICATE] GET_CERTIFICATE_SUCCESS');
    readonly type = GetCertificateSuccess.type;

    constructor(public payload: Certification) {}
  }

  export class GetCertificateError implements Action {
    static readonly type = type<'[CERTIFICATE] GET_CERTIFICATE_ERROR'>('[CERTIFICATE] GET_CERTIFICATE_ERROR');
    readonly type = GetCertificateError.type;
  }

  export class UpdateCertificationLogo implements Action {
    static readonly type = type<'[CERTIFICATE] UpdateCertificationLogo'>('[CERTIFICATE] UpdateCertificationLogo');
    readonly type = UpdateCertificationLogo.type;

    constructor(public payload: EntityImageConfig) {}
  }

  export class GetDefaultEducationActivities implements Action {
    static readonly type = type<'[CERTIFICATE] GetDefaultEducationActivities'>(
      '[CERTIFICATE] GetDefaultEducationActivities',
    );
    readonly type = GetDefaultEducationActivities.type;
  }

  export class GetDefaultEducationActivitiesSuccess implements Action {
    static readonly type = type<'[CERTIFICATE] GetDefaultEducationActivitiesSuccess'>(
      '[CERTIFICATE] GetDefaultEducationActivitiesSuccess',
    );
    readonly type = GetDefaultEducationActivitiesSuccess.type;

    constructor(public payload: DefaultActivityType[]) {}
  }

  export class GetDefaultEducationActivitiesError implements Action {
    static readonly type = type<'[CERTIFICATE] GetDefaultEducationActivitiesError'>(
      '[CERTIFICATE] GetDefaultEducationActivitiesError',
    );
    readonly type = GetDefaultEducationActivitiesError.type;
  }

  export class Reset implements Action {
    static readonly type = type<'[CERTIFICATE] RESET'>('[CERTIFICATE] RESET');
    readonly type = Reset.type;
  }

  export class SetIsPublishAfterImageUpload implements Action {
    static readonly type = type<'[CERTIFICATE] SetIsPublishAfterImageUpload'>(
      '[CERTIFICATE] SetIsPublishAfterImageUpload',
    );
    readonly type = SetIsPublishAfterImageUpload.type;

    constructor(public payload: boolean) {}
  }

  export class SetPublishCertificationData implements Action {
    static readonly type = type<'[CERTIFICATE] SetPublishCertificationData'>(
      '[CERTIFICATE] SetPublishCertificationData',
    );
    readonly type = SetPublishCertificationData.type;

    constructor(public payload: PublishCertificationData) {}
  }

  export class GetBriefNotificationsSettingsCert implements Action {
    static readonly type = type<'[CERTIFICATE] GET_BRIEF_NOTIFICATIONS_SETTINGS'>(
      '[CERTIFICATE] GET_BRIEF_NOTIFICATIONS_SETTINGS',
    );
    readonly type = GetBriefNotificationsSettingsCert.type;
  }

  export class GetBriefNotificationsSettingsCertSuccess implements Action {
    static readonly type = type<'[CERTIFICATE] GET_BRIEF_NOTIFICATIONS_SETTINGS_SUCCESS'>(
      '[CERTIFICATE] GET_BRIEF_NOTIFICATIONS_SETTINGS_SUCCESS',
    );
    readonly type = GetBriefNotificationsSettingsCertSuccess.type;

    constructor(public payload: BriefNotificationsSettings) {}
  }

  export class GetBriefNotificationsSettingsCertError implements Action {
    static readonly type = type<'[CERTIFICATE] GET_BRIEF_NOTIFICATIONS_SETTINGS_ERROR'>(
      '[CERTIFICATE] GET_BRIEF_NOTIFICATIONS_SETTINGS_ERROR',
    );
    readonly type = GetBriefNotificationsSettingsCertError.type;
  }
}

export type CertificateActions =
  | ActionCreators.GetCertificate
  | ActionCreators.GetCertificateSuccess
  | ActionCreators.GetCertificateError
  | ActionCreators.UpdateCertificationLogo
  | ActionCreators.GetDefaultEducationActivities
  | ActionCreators.GetDefaultEducationActivitiesSuccess
  | ActionCreators.GetDefaultEducationActivitiesError
  | ActionCreators.Reset
  | ActionCreators.SetIsPublishAfterImageUpload
  | ActionCreators.SetPublishCertificationData
  | ActionCreators.GetBriefNotificationsSettingsCert
  | ActionCreators.GetBriefNotificationsSettingsCertSuccess
  | ActionCreators.GetBriefNotificationsSettingsCertError;
